import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Section, SectionTitle, Reveal } from "../components/UIBits";
import { useT } from "../lib/i18n";
import api from "../lib/api";

const TIERS = ["platinum", "gold", "silver", "bronze"];

export default function PartnersPage() {
    const { t } = useT();
    const [partners, setPartners] = useState([]);
    useEffect(() => { api.get("/partners").then(r => setPartners(r.data)); }, []);
    const tierLabel = { platinum: t("partners.platinum"), gold: t("partners.gold"), silver: t("partners.silver"), bronze: t("partners.bronze") };
    return (
        <div data-testid="partners-page">
            <Helmet><title>{`${t("partners.title_pre")} ${t("partners.title_accent")} — Défi Ultime`}</title></Helmet>
            <Section>
                <SectionTitle kicker={t("partners.kicker")} title={t("partners.title_pre")} accent={t("partners.title_accent")} />
                {TIERS.map(tier => {
                    const list = partners.filter(p => p.tier === tier);
                    if (!list.length) return null;
                    return (
                        <div key={tier} className="mb-12">
                            <div className="font-display text-3xl uppercase tracking-widest text-[#7FD93C] mb-4">{tierLabel[tier]}</div>
                            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                                {list.map((p, i) => (
                                    <Reveal key={p.id} delay={i * 0.04}>
                                        <a href={p.link || "#"} target="_blank" rel="noreferrer" className="glass-card p-6 flex items-center justify-center hover:border-[#7FD93C] aspect-[3/2]">
                                            {p.logo_base64 ? (
                                                <img src={p.logo_base64} alt={p.name} className="max-h-16 max-w-full object-contain" />
                                            ) : (
                                                <span className="font-display text-xl tracking-wider text-white/70">{p.name}</span>
                                            )}
                                        </a>
                                    </Reveal>
                                ))}
                            </div>
                        </div>
                    );
                })}
                {partners.length === 0 && <div className="text-white/50">{t("partners.empty")}</div>}
            </Section>
        </div>
    );
}
